import s from './styles.module.scss'
import Link from 'next/link'
import aliancaPositivo from '+/alianca-positivo.svg'
import Image from 'next/image'

const Footer = () => {
  const socialItems = [
    {
      label: 'Instagram',
      href: 'https://www.instagram.com/maersk_official/',
    },
    {
      label: 'LinkedIn',
      href: 'https://www.linkedin.com/company/maersk-group/',
    },
    {
      label: 'Youtube',
      href: 'https://www.youtube.com/@maersk?sub_confirmation=1',
    },
  ]

  const institutionalItems = [
    {
      label: 'Termos e Condições',
      href: 'https://www.alianca.com.br/e-commerce',
    },
    {
      label: 'Aviso Legal',
      href: 'https://www.alianca.com.br/politica-de-privacidade',
    },
    {
      label: 'Fornecedores',
      href: 'https://www.maersk.com/procurement',
    },
  ]
  return (
    <footer className={`${s.container} mds`}>
      <div className={s.socials}>
        {socialItems.map(item => (
          <a
            key={item.label}
            href={item.href}
            target="_blank"
            data-cy-item={`footer-a-${item.label}`.toLowerCase()}>
            {item.label}
          </a>
        ))}
      </div>
      <div className={s.divider} />
      <div className={s.content}>
        <Image
          src={aliancaPositivo}
          alt="Logotipo Aliança"
          style={{transform: 'translateY(5px)'}}
        />
        <menu className={s.links}>
          {institutionalItems.map(item => (
            <a
              key={item.label}
              href={item.href}
              data-cy-item={`footer-a-${item.label.replaceAll(' ', '-')}`.toLowerCase()}
              target="_blank">
              {item.label}
            </a>
          ))}
          <span className={s.maersk}>
            ©{new Date().getFullYear()} Aliança - A Maersk Company
          </span>
        </menu>
      </div>
    </footer>
  )
}

export default Footer
